import type { TranslationKey } from "../../../../localization/translations"
import { UserWorkgroup } from "../../../../users/userTypes"

export type CompanyUserFormMode = "create" | "update"

export type CompanyUserFormValues = Readonly<{
    // User details
    employeeId: string
    displayName: string
    initials: string
    username: string
    email: string
    mobileNumber: string
    phoneNumber: string
    language: string
    userGroupId: string
    departmentId: string
    // Approvals
    approverForUserGroupIds: ReadonlyArray<number>
    // Catalog access
    assignedPriceListIds: ReadonlyArray<number>
    // Settings
    sendEmailInvitation: boolean
    disableUserSync: boolean
    isSecretary: boolean
    notifyOnGuestArrival: boolean
    isActive: boolean
    // Workgroups
    workgroups: ReadonlyArray<UserWorkgroup>
}>

export type UserLanguageOption = Readonly<{
    value: string
    labelKey: TranslationKey
}>

// TODO(open-item): confirm the canonical supported-language source and reuse it here instead of this const.
export const USER_LANGUAGE_OPTIONS: ReadonlyArray<UserLanguageOption> = [
    { value: "da_DK", labelKey: "company-user-language-option-danish" },
    { value: "en_US", labelKey: "company-user-language-option-english" },
]
